export const bills = `<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
width="124.984px" height="124.984px" viewBox="0 0 124.984 124.984" style="enable-background:new 0 0 124.984 124.984;"
xml:space="preserve">
<g>
<g>
   <path d="M105.625,87.618c2.568-5.21,2.736-11.492-1.707-15.548c2.006-5.902,0.354-13.309-5.609-15.5
       c1.062-3.636,1.342-7.725-0.587-10.992c-1.741-2.949-5.287-3.719-8.497-3.634c3.49-7.532,8.768-16.931,15.723-23.692l0.978-0.949
       l-0.822-1.087c-0.562-0.744-13.967-18.163-31.008-12.89L72.919,3.69l0.093,1.227c0.024,0.31,2.218,30.509-4.166,43.979
       c-0.578,0.309-1.153,0.618-1.722,0.927c-0.932-2.884-2.075-5.787-3.441-8.569c-2.778-6.436-7.078-14.921-12.894-22.191
       c2.744-2.411,1.345-6.371,0.307-8.458c3.642-3.166,9.018-6.734,15.224-7.383c0.61,1.704,2.032,4.724,4.577,5.597
       c-0.095-2.248-0.194-3.623-0.2-3.687L70.512,2.68l2.349-0.728c0.912-0.282,1.834-0.492,2.762-0.663l-0.961-0.297
       C57.619-4.28,44.215,13.138,43.653,13.882l-0.822,1.087l0.976,0.95c7.411,7.205,12.921,17.407,16.389,25.152
       c-10.391,3.558-14.177,12.531-17.517,20.448c-2.32,5.501-4.35,10.301-8.111,12.136l-0.125-0.381l-1.16-3.562l-16.858,5.492
       l16.218,49.779l16.859-5.492l-0.975-2.993c15.287-4.436,31.205-6.159,46.669-9.845c4.75-1.132,9.687-2.249,12.308-6.694
       C109.734,96.184,108.106,91.034,105.625,87.618z M25.604,83.219l-1.605-4.927l4.924-1.604l1.605,4.925L25.604,83.219z
        M75.746,32.917c0.451,1.879,2.025,3.732,4.324,4.798c3.457,1.601,7.227,0.813,8.418-1.763c1.194-2.574-0.642-5.96-4.098-7.562
       c-3.423-1.585-7.148-0.824-8.38,1.691c0.571-6.966,0.548-13.837,0.403-18.679c3.471-0.009,5.304-3.843,6.022-5.847
       c6.205,0.649,11.581,4.218,15.224,7.383c-1.039,2.087-2.438,6.046,0.307,8.458c-5.45,6.813-9.564,14.686-12.346,20.947
       c-4.325,0.763-8.569,2.453-12.633,4.429C74.352,42.695,75.219,37.854,75.746,32.917z M60.424,41.577
       c-0.008,0.011-0.015,0.021-0.023,0.032l-0.117-0.343C60.331,41.37,60.379,41.476,60.424,41.577z M100.869,98.708
       c-4.021,2.49-9.832,3.179-14.367,4.098c-12.852,2.606-26.941,4.316-39.551,7.984L36.474,79.437
       c5.846-2.435,9.388-9.26,11.933-15.295c2.872-6.809,5.852-13.832,13.292-16.653c0.928,2.251,1.545,4.396,2.291,7.016
       c0.396,1.393,1.996,1.717,3.135,1.094c6.005-3.281,12.513-6.824,19.359-8.003c0.049,0.017,0.1,0.028,0.148,0.047
       c0.012-0.026,0.023-0.054,0.033-0.08c0.115-0.019,0.228-0.043,0.343-0.06c2.073-0.319,5.433-0.531,6.489,1.806
       c0.791,1.748,0.513,3.83,0.141,5.644c-0.219,1.066-0.734,2.67-0.84,2.931c-0.462,1.135-0.02,2.815,1.417,2.986
       c5.495,0.651,6.28,6.889,4.21,11.146c-0.376,0.772-0.292,1.964,0.473,2.505c4.348,3.07,3.627,7.937,1.211,12.087
       c-0.334,0.572-0.332,1.576,0.118,2.097C102.609,91.461,104.833,96.253,100.869,98.708z"/>
   <path d="M64.365,26.057c-3.456,1.602-5.292,4.988-4.098,7.562c1.192,2.575,4.961,3.364,8.418,1.763
       c0.525-0.243,1.006-0.532,1.452-0.849c0.356-2.846,0.589-5.781,0.733-8.646C69.143,24.988,66.686,24.982,64.365,26.057z"/>
</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>`;